import { Fragment } from 'react';

import CustomCalendar from 'components/modal/custom-calendar';

import './styles/tippy-top-banner.scss';

type TippyTopBannerProps = {
    custom_calendar: {
      calendar_text: string,
      calendar_url: string,
      details: string,
      details_url: string,
      text : string
    },
    enabled: boolean,
    markup: string,
    use_markup : boolean
}

export const TippyTopBanner = ({ enabled, custom_calendar, use_markup, markup }:TippyTopBannerProps) => {
  if (!enabled) {
    return null;
  }

  if (use_markup) {
    return <section
      className="tippy-top-banner-section"
      data-section="tippy top banner"
      dangerouslySetInnerHTML={ { __html: markup } }
    />;
  }
  
  return (
    <section className="tippy-top-banner-section tippy-top-payroll" data-section="tippy top banner">
      <div className="container">
        <p className="tippy-top-text">{custom_calendar.text}</p>
        <CustomCalendar className="tippy-top-cta " customCalendarUrl={ custom_calendar.calendar_url } buttonModalLaunchText={ custom_calendar.calendar_text } />
        <a href= { custom_calendar.details_url } className="tippy-top-details">{custom_calendar.details}</a>
      </div>
    </section>);
};